/** KAN-713: справочник прокси Telegram-аккаунтов: список и изменения. */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { EXPENSES_QUERY_KEY } from '@/services/api/queryKeys';
import { telegramProxiesApi } from '@/services/api/telegramProxies';
import type { TelegramProxyBody } from '@/types/telegramProxy';

export const TELEGRAM_PROXIES_QUERY_KEY = ['telegram-proxies'] as const;

/** enabled=false: не загружать (закрытый диалог в каждой строке таблицы). */
export function useTelegramProxies(enabled = true) {
  return useQuery({
    queryKey: TELEGRAM_PROXIES_QUERY_KEY,
    queryFn: telegramProxiesApi.list,
    staleTime: 30_000,
    enabled,
  });
}

/**
 * Мутация, после которой обновляется справочник (там last_check и аккаунты).
 * costs=true: меняется стоимость прокси, обновляется и отчёт о расходах (KAN-735).
 */
function useInvalidatingMutation<TArgs, TResult>(
  fn: (args: TArgs) => Promise<TResult>,
  costs = false
) {
  const client = useQueryClient();
  return useMutation({
    mutationFn: fn,
    onSuccess: () => {
      client.invalidateQueries({ queryKey: TELEGRAM_PROXIES_QUERY_KEY });
      if (costs) void client.invalidateQueries({ queryKey: EXPENSES_QUERY_KEY });
    },
  });
}

export function useTelegramProxyMutations() {
  return {
    create: useInvalidatingMutation(
      (data: TelegramProxyBody) => telegramProxiesApi.create(data),
      true
    ),
    update: useInvalidatingMutation(
      (args: { id: number; data: TelegramProxyBody }) =>
        telegramProxiesApi.update(args.id, args.data),
      true
    ),
    remove: useInvalidatingMutation((id: number) => telegramProxiesApi.remove(id), true),
    checkSaved: useInvalidatingMutation((id: number) => telegramProxiesApi.checkSaved(id)),
  };
}
